import React from "react";
import { Outlet } from "react-router-dom";
const bookingComponent = () => {
  return (
    <>
      <Outlet />
    </>
  );
};
export default bookingComponent
